<template>
    <div class="warningList">
        <div class="list">
            <van-list
            ref="vanList"
            v-model="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="onLoad"
            class="wrapper"
            >
                <div
                    class="reject"
                    v-for="(item,index) in proList"
                    :key="index"
                >
                    <div class="reject_item">
                        <div class="info">
                            <div>预警类型:</div>
                            <div>{{item.type}}</div>
                        </div>
                        <div class="info">
                            <div>预警内容:</div>
                            <div>{{item.content}}</div>

                        </div>
                        <div class="info">
                            <div>预警时间:</div>
                            <div>{{item.time}}</div>
                        </div>
                        <div class="info info1">
                            <div>属地:</div>
                            <div>{{item.areaName}}</div>

                        </div>
                    </div>
                </div>
            </van-list>
            <!-- </div> -->
            <isNoInfo :isNolist="isNolist"></isNoInfo>
        </div>
    </div>
</template>
<script>
    import api from '../../../../../service/modules/complaintApis';
    import isNoInfo from '../../../../../components/isNoInfo.vue';
    
    export default {
        components: {
            isNoInfo
        },
        data () {
            return {
                finished: false,
                finishedText: '没有更多',
                isNolist: false, // 没有内容的状态
                isload: true, // 底部加载中的状态
                loading: true,
                proList:[],
                formData:{
                    pageSize:10,
                    curPage:1,
                    
                },
                state:true,
            }
        },
        created () {
             console.log(this.$route.query);
             this.formData=Object.assign({},this.formData,this.$route.query);
             this.getList();
             console.log(this.formData);
        },
        methods: {
            getList () {
                api.worker.syntheticalWarning(this.formData).then(data=>{
                    if(data.ret==0){
                        if(data.data.list.length>0){
                            this.loading = false;
                            if(this.state){
                              this.proList=data.data.list;
                            }else{
                             this.proList = this.proList.concat(data.data.list);
                            }
                        }else{
                            this.finished = true;
                            this.loading = false;
                            if(this.state){
                              this.isNolist=true;
                            }
                        }
                    }
                })
            },
            onLoad () {
                this.formData.curPage++;
                this.state=false;
                this.getList(this.state);
            }
        }
    }
</script>
<style lang="less" scoped>
.warningList {
    .list {
        .wrapper {
            width: 100%;
            .reject {
                width: 100%;
                .reject_item {
                    margin: 20px 15px;
                    box-sizing: border-box;
                    background-color: #fff;
                    padding: 4px 16px;
                    box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
                    border-radius: 3px;
                    .info {
                        display: flex;
                        margin-top: 12px;
                        div:nth-child(1) {
                            width: 70px;
                            font-size: 14px;
                            color: #777;
                            line-height: 16px;

                        }
                        div:nth-child(2) {
                            font-size: 14px;
                            color: #777;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            line-height: 16px;
                        }
                    }
                    .info1{
                        padding-bottom: 12px;
                    }
                    .line {
                        width: 100%;
                        height: 1px;
                        background-color: #eee;
                        margin-top: 25px;
                    }
                    .status {
                        text-align: center;
                        width: 100%;
                        padding: 20px 0;
                        font-size: 18px;
                        color: #666;
                    }
                }
                .space {
                    width: 100%;
                    height: 4px;
                    background-color: #eee;
                }
            }

        }
    }
}
</style>
